import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import UserModalPage from '../../../containers/masters/user/UserModalPage'
import BubbleMeterUO2 from '../../commons/BubbleMeterUO2'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import InputTreeSelect from '../../commons/form/InputTreeSelect'
import InputSelect from '../../commons/form/InputSelect'
import { loadTemplatesNames } from '../../../constants/backendIds'
import ModalMassUploadPage from '../../../containers/masters/ModalMassUpload/ModalMassUploadPage'
import UserSubscriptionsModal from './subscriptions/UserSubscriptionsModal'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class UserAdmin extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        searchUO: [],
        searchRole: [],
        searchName: null,
        searchEmail: null
      },
      showModal: false,
      showSubscriptionsModal: false,
      userId: null
    }
    this.searchUsers = this.searchUsers.bind(this)
  }

  componentDidMount () {
    this.props.actions.fetchRoleCombo()
    this.searchUsers()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchUserList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchUserList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleRolChange (searchRole) {
    if (this.state.filter.searchRole !== searchRole) {
      this.setState({ filter: { ...this.state.filter, searchRole: searchRole } })
    }
  }

  handleOrganizedUnitChange (searchUO) {
    if (!searchUO || searchUO.length === 0) {
      this.setState({ filter: { ...this.state.filter, searchUO: [] } })
      return
    }
    const searchUoList = searchUO.split(',').map((item) => {
      return parseInt(item)
    })
    if (this.state.filter.searchUO !== searchUoList) {
      this.setState({ filter: { ...this.state.filter, searchUO: searchUoList } })
    }
  }

  handleNameChange (searchName) {
    if (this.state.filter.searchName !== searchName) {
      this.setState({ filter: { ...this.state.filter, searchName } })
    }
  }

  handleEmailChange (searchEmail) {
    if (this.state.filter.searchEmail !== searchEmail) {
      this.setState({ filter: { ...this.state.filter, searchEmail } })
    }
  }

  searchUsers () {
    this.props.actions.fetchUserList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  openUserModalLoad () {
    this.setState({ showModal: true })
    this.props.actions.openModalMass('ADMIN.USERS.MODAL_UPLOAD.', this.props.actions.uploadUserMassDocument, this.searchUsers)
  }

  closeUserModalLoad () {
    this.setState({ showModal: false })
  }

  openUserSubscriptionsModal (userId) {
    this.setState({ showSubscriptionsModal: true, userId })
  }

  closeUserSubscriptionsModal () {
    this.setState({ showSubscriptionsModal: false })
  }

  resetFilters () {
    this.setState({
      filter: {
        searchRole: null,
        searchName: null,
        searchEmail: null,
        searchUO: null
      }
    }, () => { this.searchUsers() })
  }

  render () {
    const {
      t, userList, pagesCount, filter, usersCount, eventSubscriptions, enableSubscriptions, defaultLanguageId,
      filter: { page },
      combos: { UOTreeCombo, roleCombo, lowestOrganizedUnitsCombo, languages, events },
      actions: {
        openEditUserModal, openAddUserModal, fetchUserList, deleteUser, recoverUser, fetchTemplateFile,
        saveEventSubscriptionFromAdmin, removeEventSubscriptionFromAdmin, fetchEventsCombo, fetchLowestOrganizedUnits,
        fetchEventSubscriptionsFromAdmin, enableEventSubscriptionFromAdmin, disableEventSubscriptionFromAdmin
      }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'adminUsersPage' })
    const tKey = 'ADMIN.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const recoverTooltip = (<Tooltip id="recoverTooltip">{t(`${tKey}RECOVER`)}</Tooltip>)
    const editSubcriptions = (<Tooltip id="recoverTooltip">{t(`${tKey}EDIT`)} {t(`${tKey}SUBSCRIPTIONS.TITLE`)}</Tooltip>)
    const downloadTemplateTooltip = (<Tooltip id="userTooltip">{t('MASTERS.DOWNLOAD')}</Tooltip>)

    const hasFilters = (this.state.filter.searchName || this.state.filter.searchEmail ||
       (this.state.filter.searchRole !== null && this.state.filter.searchRole.length > 0) || (this.state.filter.searchUO !== null && this.state.filter.searchUO.length > 0))

    return (
      <div id='userAdmin' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openAddUserModal()}>
              <i className='iDocIcon-add-plus'></i>{t('MASTERS.ADD')}
            </Button>
            <OverlayTrigger placement="left" overlay={downloadTemplateTooltip}>
              <Button
                className="_Btn accent o-icn"
                onClick={() => fetchTemplateFile(loadTemplatesNames.users) }
              >
                <i className='iDocIcon-download'></i>
              </Button>
            </OverlayTrigger>
            <OverlayTrigger placement="left" overlay={<Tooltip id="editProductTooltip">{' ' + t(`${tKey}RECURRENT_ENTITIES.MODAL_MASS_UPLOAD.UPLOAD_DOCUMENT`)}</Tooltip>}>
              <Button
                className="_Btn new o-icn"
                onClick={this.openUserModalLoad.bind(this)}
              >
                <i className='iDocIcon-file-excel' />
              </Button>
            </OverlayTrigger>

          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                name="filters.rol"
                controlLabel={t(`${tKey}USERS.ROL`)}
                placeholder={t(`${tKey}USERS.ROL`)}
                multi={true}
                valueKey="id"
                labelKey="value"
                options={roleCombo}
                onInputChange={(value) => this.handleRolChange(value)}
              />
              <Field
                component={InputTreeSelect}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                name="filters.organizedUnit"
                controlLabel={t(`${tKey}USERS.UO`)}
                placeholder={t(`${tKey}USERS.UO`)}
                multi={true}
                valueKey="value"
                labelKey="label"
                childrenKey="children"
                options={UOTreeCombo}
                onInputChange={(value) => this.handleOrganizedUnitChange(value)}
              />
              <Field
                component={InputText}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                id="name"
                name="filters.name"
                controlLabel={t(`${tKey}USERS.NAME`)}
                placeholder={t(`${tKey}USERS.NAME`)}
                onInputChange={(value) => this.handleNameChange(value)}
              />
              <Field
                component={InputText}
                colWidth={25} // 25, 33, 50, 75, 100 default=25
                id="email"
                name="filters.email"
                controlLabel={t(`${tKey}USERS.EMAIL`)}
                placeholder={t(`${tKey}USERS.EMAIL`)}
                onInputChange={(value) => this.handleEmailChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.searchUsers()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>

            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              {userList.length !== 0 &&
              <Table className="editable-table admin-users" hover responsive>
                <thead>
                  <tr>
                    <th style={{ display: 'none' }} onClick={() => { this.changeOrder('code') }}>
                      {t(`${tKey}USERS.CODE`)}&nbsp;
                      <i className={this.getSortIcon('code')} />
                    </th>
                    <th onClick={() => { this.changeOrder('name') }}>
                      {t(`${tKey}USERS.NAME_SURNAME`)}&nbsp;
                      <i className={this.getSortIcon('name')} />
                    </th>
                    <th onClick={() => { this.changeOrder('emailaddress') }}>
                      {t(`${tKey}USERS.EMAIL`)}&nbsp;
                      <i className={this.getSortIcon('emailaddress')} />
                    </th>
                    <th>
                      {t(`${tKey}USERS.PASSWORD_EXPIRED`)}&nbsp;
                    </th>
                    <th>{t(`${tKey}USERS.UO_ROL`)}</th>
                    <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                  </tr>
                </thead>
                <tbody>
                  {userList && userList.map((user, idx) => (
                    <tr key={idx} className={(!user.isActive ? 'is-deleted' : '')}>
                      <td style={{ display: 'none' }}>{user.userId}</td>
                      <td>{user.name} {user.surnames}</td>
                      <td>{user.emailAddress}</td>
                      <td className="tempPass">
                        {user.isTemp &&
                          <i className="ico-cancel" />}
                        {user.isTemp === false &&
                          <i className="ico-check" />}
                      </td>
                      <td>
                        {user.organizedUnits && [
                          <span key="lable" className="tree-list-label tree-list-item">{user.organizedUnits[0].name}</span>,
                          <BubbleMeterUO2 key="bubble" listItems={user.organizedUnits} />
                        ]}
                      </td>
                      <td className='actions'>
                        {user.isActive
                          ? (
                            <div>
                              {enableSubscriptions && (
                                <OverlayTrigger placement="left" overlay={editSubcriptions}>
                                  <a className='_Btn accent stk o-icn ' onClick={() => this.openUserSubscriptionsModal(user.userId)}>
                                    <i className="iDocIcon-bell"></i>
                                  </a>
                                </OverlayTrigger>
                              )}
                              <OverlayTrigger placement="left" overlay={editTooltip}>
                                <a className='_Btn accept stk o-icn ' onClick={() => openEditUserModal(user.userId)}>
                                  <i className="iDocIcon-edit" />
                                </a>
                              </OverlayTrigger>
                              <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                <a className='_Btn cancel stk o-icn ' onClick={() => deleteUser(user.userId, { ...filter, ...this.state.filter })}>
                                  <i className="iDocIcon-delete-forever" />
                                </a>
                              </OverlayTrigger>
                            </div>
                          ) : (
                            <div>
                              <OverlayTrigger placement="left" overlay={recoverTooltip}>
                                <a className='_Btn accent stk o-icn ' onClick={() => recoverUser(user.userId, { ...filter, ...this.state.filter })}>
                                  <i className='iDocIcon-undo-back' />
                                </a>
                              </OverlayTrigger>
                            </div>
                          )
                        }
                      </td>
                    </tr>))
                  }
                </tbody>
              </Table>
              }
              {(userList === null || userList === undefined || userList.length === 0) &&
                <p className="no_results" >{t(`${tKey}USERS.RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={usersCount}
                    onSelectAction={(value) => fetchUserList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <UserSubscriptionsModal
          actions = {{
            saveEventSubscriptionFromAdmin,
            removeEventSubscriptionFromAdmin,
            closeModal: () => this.closeUserSubscriptionsModal(),
            fetchEventsCombo,
            fetchLowestOrganizedUnits,
            fetchEventSubscriptionsFromAdmin,
            disableEventSubscriptionFromAdmin,
            enableEventSubscriptionFromAdmin
          }}
          t={t}
          combos={{ lowestOrganizedUnitsCombo, languages, events }}
          userId = {this.state.userId}
          showModal = {this.state.showSubscriptionsModal}
          eventSubscriptions = {eventSubscriptions}
          defaultLanguageId = {defaultLanguageId}
        />
        <UserModalPage/>
        <ModalMassUploadPage
          showModal={this.state.showModal}
          closeModal={this.closeUserModalLoad.bind(this)}
        />
      </div>
    )
  }
}

export default reduxForm({
  form: 'listUser'
})(UserAdmin)
